/** Cap long-edge backing store so zoomed calibrate previews stay sharp without OOM. */
export const PDF_PREVIEW_MAX_RENDER_EDGE_PX = 6144;

/**
 * Device-pixel ratio for the preview canvas, boosted for zoom and capped by edge.
 * CSS size stays fit-to-pane; backing store grows with {@link renderBoost}.
 */
export const resolvePdfPreviewPixelRatio = (options: {
  cssWidth: number;
  cssHeight: number;
  devicePixelRatio: number;
  renderBoost?: number;
  maxEdgePx?: number;
}): number => {
  const dpr = Math.max(1, options.devicePixelRatio);
  const boost = Math.max(1, options.renderBoost ?? 1);
  const maxEdge = options.maxEdgePx ?? PDF_PREVIEW_MAX_RENDER_EDGE_PX;
  const cssEdge = Math.max(options.cssWidth, options.cssHeight, 1);
  const uncapped = dpr * boost;
  const capped = maxEdge / cssEdge;
  return Math.max(1, Math.min(uncapped, capped));
};
